import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfArtifactReleasePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      pages: {
        artifactReleases: {
          title: "制品发布物",
          subtitle: "登记已在版本控制仓库 Hub 中产出的不可变附件制品，作为发布版本绑定来源。",
          createAction: "登记制品",
          createTitle: "登记附件制品",
          createSuccess: "制品已登记",
          loadFailed: "加载制品发布物失败"
        }
      }
    }
  },
  en: {
    ctf: {
      pages: {
        artifactReleases: {
          title: "Artifact Releases",
          subtitle: "Register immutable attachment artifacts produced by the repository hub.",
          createAction: "Register artifact",
          createTitle: "Register attachment artifact",
          createSuccess: "Artifact registered",
          loadFailed: "Failed to load artifact releases"
        }
      }
    }
  },
  ja: {
    ctf: {
      pages: {
        artifactReleases: {
          title: "成果物",
          subtitle: "リポジトリ Hub で生成済みの不変な添付成果物を登録します。",
          createAction: "成果物登録",
          createTitle: "添付成果物登録",
          createSuccess: "成果物を登録しました",
          loadFailed: "成果物の読み込みに失敗しました"
        }
      }
    }
  }
};
